import { useMemo } from "react";
import { FetchOptions } from "@danishagro/shared/src/interfaces/fetchOptions.interface";
import { getApiUrl } from "@danishagro/shared/src/helpers/getApiUrl.helper";
import { B2C_API_ROOT } from "@danishagro/shared/src/constants/urlRoot.constants";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QueryObject = Record<string, any>;

export const useAuthRequestB2C = () => {
    return useMemo(
        () => ({
            get: (path: string, parameters?: QueryObject, options?: FetchOptions) => {
                const opts = {
                    ...options,
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                };
                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }
                return fetch(getApiUrl(B2C_API_ROOT, path, parameters), opts).then(
                    (response) => response
                );
            },
            post: (
                path: string,
                parameters: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
            patch: (
                path: string,
                parameters: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }
                // console.log("PATCH", path, getApiUrl(B2C_API_ROOT, path));

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
            delete: (
                path: string,
                parameters: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
        }),
        []
    );
};
